import { createContext, useContext } from 'react'
import { SignInBody } from 'types/services'

interface AuthContextType {
  user: any
  userInfos: any
  loading: boolean
  signin: (body: SignInBody, callback?: VoidFunction) => void
  signup: (body: any, callback?: VoidFunction) => void
  signout: (type: string) => void
  fetchUser: () => void
}

export const AuthContext = createContext<AuthContextType>(null!)

export function useAuthContext() {
  return useContext(AuthContext)
}
